import React from 'react';
import SocialMediaLinks from '../Header/SocialMediaLinks';

const SocialMediaSection = ({ dataHeader }) => (
  <div className="flex flex-col bg-[#F3F6F9] rounded-[35px] py-14 px-4 lg:mb-8 mb-4">
    <span className="block mb-2 font-medium text-themeSecondColor">
      Temasta kalın
    </span>
    <SocialMediaLinks  dataHeader={dataHeader} />
  </div>
);

export default SocialMediaSection;
